import { chainID, type NamadaChainInfo } from '@polaris/core/namada'
import { useMemo } from 'react'
import {
  usePreferredEndpoint,
  useSupportedChains,
} from '@/src/queries/hooks/chains'

/**
 * Hook to get Namada chain info with priority:
 * 1. Preferred endpoint from backend
 * 2. RPC URL from chain metadata
 */
export const useNamadaChain = (): NamadaChainInfo | undefined => {
  const { data: chains } = useSupportedChains()
  const { data: preferredEndpoint } = usePreferredEndpoint(chainID)

  return useMemo(() => {
    // Priority 1: Use preferred endpoint from backend
    if (preferredEndpoint?.url) {
      return {
        chainId: chainID,
        rpcUrl: preferredEndpoint.url,
      }
    }

    // Priority 2: Use RPC URL from chain metadata
    const namadaChain = chains?.find((chain) => chain.chain_id === chainID)
    const chainMetadataRpcUrl = namadaChain?.cosmos_data?.rpc_urls?.[0]

    if (chainMetadataRpcUrl) {
      return {
        chainId: chainID,
        rpcUrl: chainMetadataRpcUrl,
      }
    }
  }, [preferredEndpoint, chains])
}
